
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Zap } from "lucide-react";
import { BaseColorPrediction } from "@/hooks/color-check/types";

interface BasePredictionSectionProps {
  basePrediction: BaseColorPrediction;
  hasExactColorMatches: boolean;
}

const BasePredictionSection = ({ basePrediction, hasExactColorMatches }: BasePredictionSectionProps) => {
  const confidencePercentage = Math.round(basePrediction.confidence * 100);

  return (
    <div>
      <h4 className="font-medium text-sm mb-2 flex items-center">
        <Zap className="mr-1 h-4 w-4 text-orange-500" />
        Slimme Basis Kleur Voorspelling
        {hasExactColorMatches && (
          <Badge className="ml-2 bg-orange-100 text-orange-800 text-xs">
            Gebaseerd op exacte maat match
          </Badge>
        )}
      </h4>
      <div className="bg-gradient-to-r from-orange-50 to-yellow-50 p-3 rounded-lg">
        <div className="flex items-center justify-between mb-2">
          <span className="text-lg font-bold text-orange-800">
            {basePrediction.baseColor}
          </span>
          <Badge className="bg-orange-100 text-orange-800">
            {confidencePercentage}% zekerheid
          </Badge>
        </div>
        <p className="text-sm text-orange-700">
          {basePrediction.reasoning}
        </p>
        
        {basePrediction.alternatives.length > 0 && (
          <div className="mt-2">
            <span className="text-xs text-orange-600">Alternatieven: </span>
            <div className="flex gap-1 mt-1">
              {basePrediction.alternatives.map((alt, index) => (
                <Badge key={index} variant="outline" className="text-xs">
                  {alt.baseColor} ({Math.round(alt.confidence * 100)}%)
                </Badge>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BasePredictionSection;
